import { Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Shell } from './components/Shell.js';

const Dashboard = lazy(() => import('./pages/Dashboard.js').then((m) => ({ default: m.Dashboard })));
const Login = lazy(() => import('./pages/Login.js').then((m) => ({ default: m.Login })));
const AuthDone = lazy(() => import('./pages/AuthDone.js').then((m) => ({ default: m.AuthDone })));
const CleanOps = lazy(() =>
  import('./modules/cleanops/CleanOpsPage.js').then((m) => ({ default: m.CleanOpsPage })),
);
const PantryConnect = lazy(() =>
  import('./modules/pantry/PantryPage.js').then((m) => ({ default: m.PantryPage })),
);
const Platform = lazy(() =>
  import('./modules/platform/PlatformPage.js').then((m) => ({ default: m.PlatformPage })),
);
const Agent = lazy(() =>
  import('./modules/agent/AgentPage.js').then((m) => ({ default: m.AgentPage })),
);
const UsersPage = lazy(() =>
  import('./admin/UsersPage.js').then((m) => ({ default: m.UsersPage })),
);
const AuditTimelinePage = lazy(() =>
  import('./admin/AuditTimelinePage.js').then((m) => ({ default: m.AuditTimelinePage })),
);
const OrderHistoryPage = lazy(() =>
  import('./admin/OrderHistoryPage.js').then((m) => ({ default: m.OrderHistoryPage })),
);
const GuestOrder = lazy(() =>
  import('./pages/GuestOrder.js').then((m) => ({ default: m.GuestOrder })),
);

function Loader() {
  const { t } = useTranslation();
  return (
    <div className="flex h-full items-center justify-center text-text-secondary">
      {t('common.loading')}
    </div>
  );
}

export function App() {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {/* Public — guest QR landing for cafeteria orders. No Shell, no auth. */}
        <Route path="/q/:token" element={<GuestOrder />} />

        <Route path="/login" element={<Login />} />
        <Route path="/auth/done" element={<AuthDone />} />
        <Route element={<Shell />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/cleanops/*" element={<CleanOps />} />
          <Route path="/pantry/*" element={<PantryConnect />} />
          <Route path="/platform/*" element={<Platform />} />
          <Route path="/agent/*" element={<Agent />} />
          <Route path="/admin/users" element={<UsersPage />} />
          <Route path="/admin/audit" element={<AuditTimelinePage />} />
          <Route path="/admin/pantry-orders" element={<OrderHistoryPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Suspense>
  );
}
